import type { ReactNode } from 'react';
import { useNavigate } from 'react-router-dom';
import { useMenuApp } from '@/components/feature/MenuApp';

interface ScreenHeaderProps {
  titulo: string;
  subtitulo?: string;
  voltar?: boolean;
  acao?: ReactNode;
  /** Cabeçalho sobre fundo colorido (texto branco). */
  claro?: boolean;
}

// Cabeçalho de tela do app: voltar redondo 44 px branco + título + ação.
export default function ScreenHeader({
  titulo,
  subtitulo,
  voltar = false,
  acao,
  claro = false,
}: ScreenHeaderProps) {
  const navigate = useNavigate();
  const { abrir: abrirMenu } = useMenuApp();
  return (
    <header
      className={`sticky top-0 z-40 border-b backdrop-blur-md ${
        claro ? 'border-white/10 bg-primary-500/90' : 'border-background-200/70 bg-background-100/90'
      }`}
    >
      <div className="mx-auto flex w-full max-w-[720px] items-center gap-3 px-5 py-3">
        {voltar && (
          <button
            type="button"
            onClick={() => navigate(-1)}
            aria-label="Voltar"
            className={`aperta flex h-11 w-11 shrink-0 cursor-pointer items-center justify-center rounded-full shadow-pcard transition-colors ${
              claro ? 'bg-white/15 text-white' : 'bg-background-50 text-foreground-800'
            }`}
          >
            <i className="ri-arrow-left-line text-xl" aria-hidden />
          </button>
        )}
        <div className="min-w-0 flex-1">
          <h1
            className={`truncate text-[22px] font-extrabold leading-tight ${
              claro ? 'text-white' : 'text-foreground-950'
            }`}
          >
            {titulo}
          </h1>
          {subtitulo && (
            <p className={`truncate text-[13px] ${claro ? 'text-white/80' : 'text-foreground-600'}`}>
              {subtitulo}
            </p>
          )}
        </div>
        {acao && <div className="flex shrink-0 items-center">{acao}</div>}
        <button
          type="button"
          onClick={abrirMenu}
          aria-label="Menu"
          className={`aperta flex h-11 w-11 shrink-0 cursor-pointer items-center justify-center rounded-full md:hidden ${
            claro ? 'text-white hover:bg-white/10' : 'text-foreground-800 hover:bg-background-200/60'
          }`}
        >
          <i className="ri-menu-line text-[22px]" aria-hidden />
        </button>
      </div>
    </header>
  );
}